<template>
  <div>
    <div class="">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>

      <div class="container-fluid">
        <!-- <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-lg-3 col-md-6" style="">
                <select
                  class="form-control"
                  name="condition"
                  v-model="condition"
                  @change="sortDevices"
                >
                  <option value="all">{{ $t("all_alm") }}</option>
                  <option value="geofence">{{ $t("geo") }}</option>
                  <option value="temperature">{{ $t("temp") }}</option>
                  <option value="humidity">{{ $t("humid") }}</option>
                  <option value="battery">{{ $t("batt") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="card">
          <div class="card-body">
            <form @submit.prevent="onFilter" class="form-inline">
              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label
                  ><b>{{ $t("start-date") }}:</b>&nbsp;</label
                >
                <input
                  type="date"
                  name="date1"
                  class="form-control"
                  v-model="startdate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label
                  ><b>{{ $t("end-date") }}:</b>&nbsp;</label
                >
                <input
                  type="date"
                  name="date2"
                  class="form-control"
                  v-model="enddate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;">
                <button type="submit" class="btn btn-primary mr-2">
                  {{ $t("filter") }}
                </button>
              </div>
            </form>
          </div>
        </div> -->
        <div class="row">
          <div class="col-12 col-sm-8">
            <div class="card">
              <div class="card-body">
                <p
                  class="font-16 font-weight-medium mb-4"
                  style="text-transform: capitalize;"
                >
                  {{ $t("alarm_type") }}
                </p>
                <div class="row">
                  <div class="col-12 col-sm-6 details" v-if="alarm.temperature">
                    <p class="pb-2 border-btm">
                      {{ $t("min-temp") }}
                      <span class="font-14 font-weight-bold float-right"
                        >{{ alarm.temperature.min }}<sup>°</sup>C</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.temperature">
                    <p class="pb-2 border-btm">
                      {{ $t("max-temp") }}
                      <span class="font-14 font-weight-bold float-right"
                        >{{ alarm.temperature.max }}<sup>°</sup>C</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.hummidity">
                    <p class="pb-2 border-btm">
                      {{ $t("min-humid") }}
                      <span class="font-14 font-weight-bold float-right"
                        >{{ alarm.hummidity.min }}%</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.hummidity">
                    <p class="pb-2 border-btm">
                      {{ $t("max-humid") }}
                      <span class="font-14 font-weight-bold float-right"
                        >{{ alarm.hummidity.max }}%</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.battery">
                    <p class="pb-2 border-btm">
                      {{ $t("min_batt") }}
                      <span class="font-14 font-weight-bold float-right"
                        >{{ alarm.battery.min }}%</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.battery">
                    <p class="pb-2 border-btm">
                      {{ $t("max_batt") }}
                      <span class="font-14 font-weight-bold float-right"
                        >{{ alarm.battery.max }}%</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.geofence">
                    <p class="pb-2 border-btm">
                      {{ $t("geo-in") }}
                      <span class="font-14 font-weight-bold float-right">{{
                        alarm.geofence.notifyWhenIn ? "Yes" : "No"
                      }}</span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.geofence">
                    <p class="pb-2 border-btm">
                      {{ $t("geo-out") }}
                      <span class="font-14 font-weight-bold float-right">{{
                        alarm.geofence.notifyWhenOut ? "Yes" : "No"
                      }}</span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.poi">
                    <p class="pb-2 border-btm">
                      {{ $t("poi-in") }}
                      <span class="font-14 font-weight-bold float-right">{{
                        alarm.poi.notifyWhenIn ? "Yes" : "No"
                      }}</span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 details" v-if="alarm.poi">
                    <p class="pb-2 border-btm">
                      {{ $t("poi-out") }}
                      <span class="font-14 font-weight-bold float-right">{{
                        alarm.poi.notifyWhenOut ? "Yes" : "No"
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="card">
              <div class="card-body">
                <p class="font-16 font-weight-medium mb-4">
                  {{ $t("push_test_alarm") }}
                </p>
                <div class="row">
                  <div class="col-12 details">
                    <p class="pb-2 border-btm">
                      {{ $t("no_of_devices") }}
                      <span class="font-14 font-weight-bold float-right">{{
                        alarm.devices.length
                      }}</span>
                    </p>
                    <p class="pb-2 border-btm">
                      {{ $t("no_of_emails") }}

                      <span class="font-14 font-weight-bold float-right">
                        {{ alarm.notify.emails.length }}
                      </span>
                    </p>
                    <p class="pb-2 border-btm">
                      {{ $t("no_of_phone_nos") }}

                      <span class="font-14 font-weight-bold float-right">
                        {{ alarm.notify.phones.length }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="mssg"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>

        <div v-if="alarmExcursions" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <AlarmTable
                  :stats="sorteddevices"
                  :paginationMeta="alarmExcursionsMeta"
                  @pageChange="pageChange"
                  @doSearch="doSearch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import moment from 'moment';
import AlarmTable from "../../components/AlarmTable.vue";
import axios from "axios";

export default {
  name: "AlarmHistory",
  components: {
    Loading,
    AlarmTable,
  },
  data() {
    return {
      condition: "all",
      isLoading: true,
      fullPage: true,
      devicesclone: [],
      sorteddevices: [],
      filteredAlarms: [],
      startdate: "",
      starttime: "00:00",
      enddate: "",
      endtime: "23:59",
      mssg: "",
      getNotificationspaginationMeta: {},
    };
  },
  mounted() {
    const params = {
      limit: 10,
      page: 1,
    };
    this.handleGetNotifications(params);
    // this.getAlarmExcursions(this.$route.params.alarmId);
  },
  beforeRouteLeave(to, from, next) {
    // introJs().exit();
    next();
  },
  computed: {
    ...mapGetters([
      "filteredNotfications",
      // "getNotificationspaginationMeta",
      "alarmExcursionsMeta",
      "alarmExcursions",
      "alarmExcursionsMeta",
      "alarm",
    ]),
  },
  methods: {
    ...mapActions([
      "getNotifications",
      "getFilteredNotifications",
      "getSearchedNotifications",
      "getAlarmExcursions",
    ]),
    startIntroJs() {
      // introJs().start();
    },
    doSearch(param, searchQuery) {
      let params = {
        ...param,
        name: searchQuery,
      };
      this.isLoading = true;
      this.handleGetNotifications(params);
    },
    pageChange(params) {
      this.handleGetNotifications(params);
    },
    handleGetNotifications(params) {
      this.isLoading = true;
      this.getAlarmExcursions({ params, id: this.$route.params.alarmId }).then(
        () => {
          this.devicesclone = this.alarmExcursions;
          this.sorteddevices = this.alarmExcursions;
          // if (this.profile.role === 'staff') {
          //   // this.devicesclone = this.devices.filter(device => !device.users.length || device.users.includes(this.profile._id));
          //   this.devicesclone = this.devices.filter(
          //     (device) =>
          //       (!device.users.length && device.settings.status == 'public') ||
          //       device.users.includes(this.profile._id)
          //   );
          //   this.sorteddevices = this.devicesclone;
          // }
          this.isLoading = false;
        }
      );
    },
    sortDevices() {
      if (this.condition == "all") {
        this.sorteddevices = this.devicesclone;
      } else if (this.condition == "geofence") {
        this.sorteddevices = this.devicesclone.filter(
          (device) => device.type == "Geofence"
        );
      } else if (this.condition == "temperature") {
        this.sorteddevices = this.devicesclone.filter(
          (device) => device.type == "Temperature"
        );
      } else if (this.condition == "humidity") {
        this.sorteddevices = this.devicesclone.filter(
          (device) => device.type == "Humidity"
        );
      } else if (this.condition == "battery") {
        this.sorteddevices = this.devicesclone.filter(
          (device) => device.type == "Battery"
        );
      }
    },

    initialiseReport(period) {
      this.getFilteredNotifications(period)
        .then(() => {
          this.sorteddevices = this.filteredNotfications;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },

    onFilter() {
      this.mssg = "";
      if (this.startdate && this.enddate) {
        this.isLoading = true;
        let period = {
          start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
          end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
        };
        this.initialiseReport(period);
      } else {
        this.mssg = "Please select a period to view";
      }
    },
  },
  watch: {
    startdate: {
      handler: function() {
        if (this.startdate !== "") this.mssg = "";
      },
    },
  },
};
</script>
<style scoped>
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
.border-btm {
  border-bottom: 1px solid #e1e7ec;
}

.details p {
  color: #8693a5;
}

p span {
  color: black;
}
</style>
